<template>
  <v-container>
    <h3>Banners</h3>
    <v-row>
      <v-col
        cols="12"
        md="10"
      >
        <draggable v-model="banner_list" group="people" @start="drag=true" @end="drag=false">
          <div v-for="(item, index) in banner_list" :key="index">
            <div class="banner-block">
              <v-row>
                <v-col md="11" sm="10" cols="10">
                  <v-row>
                    <v-col cols="12" md="6"> <!-- banner image -->
                      <v-img
                        lazy-src="https://picsum.photos/id/11/10/6"
                        :src="item.display"
                        aspect-ratio="0.26"
                        :max-width="300"
                        :max-height="78"
                        :eager="true"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div>
                        <v-file-input
                          :rules="[rules.banner_image_url]"
                          accept="image/*"
                          placeholder="Select banner image"
                          prepend-icon="mdi-camera"
                          ref="image"
                          dense
                          v-model="item.file"
                          @change="uploadBanner(index)"
                        ></v-file-input>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6"> <!-- banner mobile image -->
                      <v-img
                        lazy-src="https://picsum.photos/id/11/10/6"
                        :src="item.display_mobile"
                        aspect-ratio="0.81"
                        :max-width="96"
                        :max-height="78"
                        :eager="true"
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div>
                        <v-file-input
                          :rules="[rules.banner_image_mobile_url]"
                          accept="image/*"
                          placeholder="Select banner image"
                          prepend-icon="mdi-camera"
                          ref="image"
                          dense
                          v-model="item.file_mobile"
                          @change="uploadMobileBanner(index)"
                        ></v-file-input>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="2" md="4"> <!-- active -->
                      <v-switch
                        v-model="item.active"
                        label="Available"
                        inset
                        color="orange"
                        dense
                      ></v-switch>
                    </v-col>
                    <v-col cols="12" md="4"> <!-- link -->
                      <v-text-field
                        v-model="item.link"
                        label="Link"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"> <!-- title -->
                      <v-text-field
                        v-model="item.title"
                        label="Title"
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6" lg="4"> <!-- start date -->
                      <div>
                        <div
                          :class="[`subtitle-1`]"
                        >
                          <b>Start date:</b>
                          {{ item.start_date }}
                          <v-btn
                            tile
                            outlined
                            color="orange"
                            @click="item.displayStartDate = !item.displayStartDate"
                          >
                            Select date
                            <v-icon>mdi-calendar</v-icon>
                          </v-btn>
                          <v-btn
                            @click="item.start_date = null"
                            small
                            text
                            color="red"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-date-picker
                          v-show="item.displayStartDate"
                          v-model="item.start_date"
                          color="orange"
                          elevation="8"
                          @change="item.displayStartDate = false"
                        ></v-date-picker>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" lg="4"> <!-- end date -->
                      <div>
                        <div
                          :class="[`subtitle-1`]"
                        >
                          <b>End date:</b>
                          {{ item.end_date }}
                          <v-btn
                            tile
                            outlined
                            color="orange"
                            @click="item.displayEndDate = !item.displayEndDate"
                          >
                            Select date
                            <v-icon>mdi-calendar</v-icon>
                          </v-btn>
                          <v-btn
                            @click="item.end_date = null"
                            small
                            text
                            color="red"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <v-date-picker
                          v-show="item.displayEndDate"
                          v-model="item.end_date"
                          color="orange"
                          elevation="8"
                          @change="item.displayEndDate = false"
                        ></v-date-picker>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                  class="banner-language"
                    v-for="(banner_lang, index2) in item.banner_language"
                    :key="index2"
                  >
                    <v-row>
                      <v-col cols="10" md="4"> <!-- banner lang code -->
                        <v-select
                          :items="lang_code_list"
                          item-text="label"
                          item-value="value"
                          label="Language"
                          v-model="banner_lang.lang_code"
                          outlined
                          dense
                        ></v-select>
                      </v-col>
                      <v-col cols="2" md="8">
                        <p class="text-right">
                          <v-btn
                            @click="removeBannerLangItem(index, index2)"
                            class="banner-lang-remove-btn"
                            small
                            text
                            color="red"
                          > <!-- remove banner lang -->
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </p>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" md="6"> <!-- banner lang image -->
                        <v-img
                          lazy-src="https://picsum.photos/id/11/10/6"
                          :src="banner_lang.display"
                          aspect-ratio="0.26"
                          :max-width="300"
                          :max-height="78"
                          :eager="true"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <div>
                          <v-file-input
                            :rules="[rules.banner_image_url]"
                            accept="image/*"
                            placeholder="Select banner image"
                            prepend-icon="mdi-camera"
                            ref="image"
                            dense
                            v-model="banner_lang.file"
                            @change="uploadBannerLang(index, index2)"
                          ></v-file-input>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6"> <!-- banner lang mobile image -->
                        <v-img
                          lazy-src="https://picsum.photos/id/11/10/6"
                          :src="banner_lang.display_mobile"
                          aspect-ratio="0.81"
                          :max-width="96"
                          :max-height="78"
                          :eager="true"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                        <div>
                          <v-file-input
                            :rules="[rules.banner_image_mobile_url]"
                            accept="image/*"
                            placeholder="Select banner image"
                            prepend-icon="mdi-camera"
                            ref="image"
                            dense
                            v-model="banner_lang.file_mobile"
                            @change="uploadMobileBannerLang(index, index2)"
                          ></v-file-input>
                        </div>
                      </v-col>
                      <v-col cols="12" md="6"> <!-- banner lang link -->
                        <v-text-field
                          v-model="banner_lang.link"
                          label="Link"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6"> <!-- banner lang title -->
                        <v-text-field
                          v-model="banner_lang.title"
                          label="Title"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </div>
                  <v-btn
                    @click="addBannerLang(index)"
                    small
                  >
                    Add language
                  </v-btn>
                </v-col>
                <v-col md="1" sm="2" cols="2">
                  <p class="text-right">
                    <v-btn
                      @click="removeBannerItem(index)"
                      small
                      text
                      color="red"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </p>
                </v-col>
              </v-row>
            </div>
          </div>
        </draggable>
      </v-col>
    </v-row>
    <div>
      <v-btn
        class="mx-2"
        @click="addNewBannerItem"
        small
      >
        Add new banner
      </v-btn>
    </div>
    <br>
    <hr>
    <br>
    <div class="text-left">
      <v-btn
        class="mx-2"
        small
        color="orange"
        dark
        @click="updateBanner"
      >
        Update
      </v-btn>
      <v-btn
        class="mx-2"
        small
        exact
        @click="getBannerList"
      >
        Cancel
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
import draggable from 'vuedraggable'
export default {
  name: 'BannerList',
  components: {
    draggable,
  },
  data: () => ({
    rules: {
      banner_image_url: value => !value || value.size < 2000000 || 'Avatar size should be less than 2 MB!',
      banner_image_mobile_url: value => !value || value.size < 1000000 || 'Avatar size should be less than 1 MB!',
    },
    lang_code_list: [
      { label: 'Thai', value: 'TH' },
      { label: 'Chinese', value: 'CH' },
      { label: 'Japanese', value: 'JP' }
    ],
    banner_list: [],
    removed_banner_list: [],
    remove_banner_language_list: [],
    img_base_url: process.env.VUE_APP_IMG_BASE_URL
  }),
  async mounted () {
    await this.getBannerList()
  },
  methods: {
    addNewBannerItem () {
      this.banner_list.push({
        id: null,
        title: null,
        link: null,
        image_url: null,
        display: '',
        file: null,
        mobile_image_url: null,
        display_mobile: '',
        file_mobile: null,
        active: true,
        start_date: null,
        end_date: null,
        displayStartDate: false,
        displayEndDate: false,
        banner_language: []
      })
    },
    removeBannerItem (index) {
      if (this.banner_list[index].id)
        this.removed_banner_list.push(this.banner_list[index].id)
      this.banner_list.splice(index, 1)
    },
    async uploadBanner (index) {
      try {
        if (!this.banner_list[index].file || this.banner_list[index].file.size >= 2000000) {
          return false
        } else {
          let formData = new FormData()
          await formData.append('banner', this.banner_list[index].file)

          const { data } = await this.$http.post('/back-office/banners/image', formData, authHeader())
          if (data) {
            this.banner_list[index].image_url = data
            this.banner_list[index].display = `${this.img_base_url}/uploads/banners/${this.banner_list[index].image_url}`
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async uploadMobileBanner (index) {
      try {
        if (!this.banner_list[index].file_mobile || this.banner_list[index].file_mobile.size >= 1000000) {
          return false
        } else {
          let formData = new FormData()
          await formData.append('banner', this.banner_list[index].file_mobile)

          const { data } = await this.$http.post('/back-office/banners/image', formData, authHeader())
          if (data) {
            this.banner_list[index].mobile_image_url = data
            this.banner_list[index].display_mobile = `${this.img_base_url}/uploads/banners/${this.banner_list[index].mobile_image_url}`
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async updateBanner () {
      try {
        let banners = []
        for (let item of this.banner_list) {
          let banner_lang_list = []
          item.banner_language.forEach(banner_lang => {
            banner_lang_list.push({
              id: banner_lang.id,
              lang_code: banner_lang.lang_code,
              link: banner_lang.link,
              title: banner_lang.title,
              image_url: banner_lang.image_url,
              mobile_image_url: banner_lang.mobile_image_url,
            })
          })
          banners.push({
            id: item.id,
            link: item.link,
            title: item.title,
            image_url: item.image_url,
            mobile_image_url: item.mobile_image_url,
            active: item.active,
            start_date: item.start_date,
            end_date: item.end_date,
            banner_language: banner_lang_list
          })
        }
        await this.$http.put('/back-office/banners', {
          banner_list: banners,
          remove_banner_list: this.removed_banner_list,
          remove_banner_language_list: this.remove_banner_language_list
        }, authHeader())
        await this.getBannerList()
      } catch (err) {
        console.log(err)
      }
    },
    async getBannerList () {
      try {
        const { data } = await this.$http.get('/back-office/banners', authHeader())
        this.banner_list = []
        for (let item of data) {
          let banner_lang_list = []
          item.banner_lang_list.forEach(banner_lang => {
            let banner_lang_display = `${this.img_base_url}/uploads/banners/${banner_lang.image_url}`
            let banner_lang_display_mobile = `${this.img_base_url}/uploads/banners/${banner_lang.mobile_image_url}`
            banner_lang_list.push({
              id: banner_lang.id,
              lang_code: banner_lang.lang_code,
              link: banner_lang.link,
              title: banner_lang.title,
              image_url: banner_lang.image_url,
              display: banner_lang_display,
              file: null,
              mobile_image_url: banner_lang.mobile_image_url,
              display_mobile: banner_lang_display_mobile,
              file_mobile: null
            })
          })
          let display = `${this.img_base_url}/uploads/banners/${item.image_url}`
          let display_mobile = `${this.img_base_url}/uploads/banners/${item.mobile_image_url}`
          let banner = {
            id: item.id,
            title: item.title,
            link: item.link,
            image_url: item.image_url,
            display: display,
            file: null,
            mobile_image_url: item.mobile_image_url,
            display_mobile: display_mobile,
            file_mobile: null,
            active: item.active,
            start_date: item.start_date,
            end_date: item.end_date,
            displayStartDate: false,
            displayEndDate: false,
            banner_language: banner_lang_list
          }
          this.banner_list.push(banner)
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    addBannerLang (index) {
      this.banner_list[index].banner_language.push({
        id: null,
        title: null,
        link: null,
        lang_code: null,
        image_url: null,
        display: '',
        file: null,
        mobile_image_url: null,
        display_mobile: '',
        file_mobile: null,
      })
    },
    removeBannerLangItem (index, index2) {
      if (this.banner_list[index].banner_language[index2].id)
        this.removed_banner_list.push(this.banner_list[index].banner_language[index2].id)
      this.banner_list[index].banner_language.splice(index2, 1)
    },
    async uploadBannerLang (index, index2) {
      try {
        if (!this.banner_list[index].banner_language[index2].file || this.banner_list[index].banner_language[index2].file.size >= 2000000) {
          return false
        } else {
          let formData = new FormData()
          await formData.append('banner', this.banner_list[index].banner_language[index2].file)

          const { data } = await this.$http.post('/back-office/banners/image', formData, authHeader())
          if (data) {
            this.banner_list[index].banner_language[index2].image_url = data
            this.banner_list[index].banner_language[index2].display = `${this.img_base_url}/uploads/banners/${this.banner_list[index].banner_language[index2].image_url}`
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async uploadMobileBannerLang (index, index2) {
      try {
        if (!this.banner_list[index].banner_language[index2].file_mobile || this.banner_list[index].banner_language[index2].file_mobile.size >= 1000000) {
          return false
        } else {
          let formData = new FormData()
          await formData.append('banner', this.banner_list[index].banner_language[index2].file_mobile)

          const { data } = await this.$http.post('/back-office/banners/image', formData, authHeader())
          if (data) {
            this.banner_list[index].banner_language[index2].mobile_image_url = data
            this.banner_list[index].banner_language[index2].display_mobile = `${this.img_base_url}/uploads/banners/${this.banner_list[index].banner_language[index2].mobile_image_url}`
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style scoped>
.banner-block {
  background-color: #f9f9f9;
  padding: 14px 20px;
  margin-bottom: 16px;
  border-radius: 6px;
}
.banner-block .banner-language {
  padding: 12px 0 0 14px;
  margin: 10px 0;
  border-top: 1px solid #dcdcdc;
}
.banner-block .banner-language:last-of-type {
  border-bottom: 1px solid #dcdcdc;
}
</style>
